/**
 * Facility revenue-share (rent) configuration.
 *
 * Rent = rent base × share, where the rent base is tuition collected in the month
 * (cash basis, tuition-first allocation, fees/materials excluded, discounts netted,
 * BHCS Cash bonus excluded) as computed by the `revenue_share_statement(p_month)` RPC.
 *
 * This value rarely changes — edit via PR. The admin UI and the CLI/MCP report accept
 * a run-time `share_pct` override for a single run (never persisted).
 *
 * Deno-side mirror: supabase/functions/_shared/revenueShare.ts (keep in sync).
 */
export const REVENUE_SHARE = {
  defaultPct: 0.25,
} as const;
